import { Component, Input, OnInit } from '@angular/core';
import { DoctorAppointment } from 'src/app/entities/appointment.entity/doctor-appointment.entity/doctor-appointment';
import { User } from 'src/app/entities/user.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';

@Component({
  selector: 'app-doctor-secretray-appointment-success',
  templateUrl: './doctor-secretary-appointment-success.component.html',
  styleUrls: ['./doctor-secretary-appointment-success.component.css']
})

export class DoctorSecretaryAppointmentSuccessComponent implements OnInit {
  @Input() doctorAppointment!: DoctorAppointment;
  get user(): User {
    return new User(this.authService.getCurrentUser()!);
  }
   constructor(private authService :AuthService) { }

  ngOnInit(): void {
  }

}
